/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";

// //import translation function for language translation
import { useTranslation } from "react-i18next";

// /*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

import ShowAgendaDetails from "../Popup/ShowAgendaDetails";

//import constext
import { GlobalProvider } from "context/GlobalContext";

import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

const AgendaBody = () => {
  const { t, i18n } = useTranslation();

  const {
    agendaWaitning,
    setAgendaWaitning,
    filterAgendaIncludeClientId,
    filterAgendaExcludeClientId,
    reloadAgenda,
    setReloadAgenda,
    filterAgendaEducatorTags,
    setFilterAgendaEducatorTags,
  } = useContext(GlobalProvider);

  const token = localStorage.getItem("token");

  const [agendaData, setAgendaData] = useState([]);

  // set agenda details params
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedShift, setSelectedShift] = useState("");
  const [selectedStarttime, setSelectedStarttime] = useState("");

  const getAllAgenda = async (month, year) => {
    try {
      setAgendaWaitning(true);

      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_AGENDA +
        `?token=${token}&month=${month}&year=${year}`;

      if (filterAgendaIncludeClientId) {
        requestUrl += `&filterincludeclient=${filterAgendaIncludeClientId}`;
      }

      if (filterAgendaExcludeClientId) {
        requestUrl += `&filterexcludeclient=${filterAgendaExcludeClientId}`;
      }

      if (filterAgendaEducatorTags.length > 0) {
        requestUrl += `&eductortags=${filterAgendaEducatorTags}`;
      }

      console.log("url of agenda body---------->", requestUrl);

      const response = await getData(requestUrl);

      console.log("Response in agenda body------->", response);

      if (response.status) {
        setAgendaWaitning(false);
        setAgendaData(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const displayDate = new Date();

  const parseAdjust = (eventDate) => {
    const date = new Date(eventDate);
    return date;
  };

  // set response to match kendo scheduler event schema --------------------------------
  const kendoCalendarData = agendaData.map((dataItem) => ({
    id: dataItem.id,
    start: parseAdjust(dataItem.start, dataItem.starttime),
    end: parseAdjust(dataItem.end, dataItem.endtime),
    isAllDay: false,
    title: dataItem.title,
    description: dataItem.description,
    ownerId: dataItem.availability,
    date: dataItem.date,
    availability: dataItem.isAvailable,
    starttime: dataItem.starttime,
    endtime: dataItem.endtime,
    color: dataItem.color,
  }));

  /*---------- Handel Edit Calendar Schedule data ------------*/
  const scheduleItemHandler = (event) => {
    const dataItem = event.resource;

    console.log(dataItem);

    setSelectedDate(dataItem.date);

    setSelectedShift(dataItem.shift);

    setSelectedStarttime(dataItem.starttime);

    const bootstrapModal = new bootstrap.Modal(
      document.getElementById("agendaDetailInfo")
    );
    bootstrapModal.show();
  };

  const handleNavigate = (date) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    getAllAgenda(month, year);
  };

  const eventStyleGetter = (event) => {
    return {
      style: {
        backgroundColor: event.resource && event.resource.color ? event.resource.color : "#3174ad",
      },
    };
  };

  useEffect(() => {
    if (
      filterAgendaIncludeClientId ||
      filterAgendaExcludeClientId ||
      filterAgendaEducatorTags.length > 0
    ) {
      const currentDate = new Date();
      const month = currentDate.getMonth() + 1; // Get the current month name
      const year = currentDate.getFullYear(); // Get the current full year

      getAllAgenda(month, year);
    }
  }, [
    filterAgendaIncludeClientId,
    filterAgendaExcludeClientId,
    filterAgendaEducatorTags,
  ]);

  useEffect(() => {
    if (reloadAgenda) {
      const currentDate = new Date();
      const month = currentDate.getMonth() + 1; // Get the current month name
      const year = currentDate.getFullYear(); // Get the current full year

      getAllAgenda(month, year);
      setReloadAgenda(false);
    }
  }, [reloadAgenda]);

  useEffect(() => {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // Get the current month name
    const year = currentDate.getFullYear(); // Get the current full year

    getAllAgenda(month, year);
  }, []);

  const resetHandler = () => {
    setSelectedDate("");

    setSelectedShift("");

    setSelectedStarttime("");
  };

  return (
    <>
      <Calendar
        localizer={localizer}
        events={agendaWaitning ? [] : (kendoCalendarData || []).map((ev) => ({
          title: ev.title || "",
          start: new Date(ev.start),
          end: new Date(ev.end),
          resource: ev,
        }))}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 600 }}
        views={["month", "week", "day", "agenda"]}
        defaultView="month"
        onSelectEvent={scheduleItemHandler}
        onNavigate={handleNavigate}
        eventPropGetter={eventStyleGetter}
      />

      <ShowAgendaDetails
        selectedDate={selectedDate}
        selectedShift={selectedShift}
        selectedStarttime={selectedStarttime}
        onCloseModal={resetHandler}
        filterAgendaIncludeClientId={filterAgendaIncludeClientId}
        filterAgendaExcludeClientId={filterAgendaExcludeClientId}
        filterAgendaEducatorTags={filterAgendaEducatorTags}
      />
    </>
  );
};

export default AgendaBody;
